// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__113Tl","savePackageButton":"ClientWallet_savePackageButton__2agGj"};